import { HttpClient, HttpHeaders, HttpBackend, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CamaraHW } from './../../../../app/_entities/galeria/videos';
import { environment } from './../../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class GaleriaVideoService {

	constructor(private http: HttpClient) {
	}

	obtenerArchivosVideo( startTime, endTime, channelList, fileType, Location, deviceID) {
		return this.http.get(environment.API_SECURITY + '/api/Howen/vehiculos', {
			responseType: 'text',
			params: {
				startTime,
				endTime,
				channelList,
				fileType,
				Location,
				deviceID
			}
		});
	}

	obtenerVideo( chs, path, deviceID) {
		return this.http.get(`${environment.API_SECURITY}/api/Howen/videoEspecifico?chs=1&path=${path}`, { responseType: 'text' })
	}

	obtenerVideoStream( chs, stream, wnum, panel, deviceID) {
		const httpHeaders = new HttpHeaders();
        httpHeaders.set('X-Content-Type-Options', 'nosniff');
		return this.http.get(`${environment.API_SECURITY}/api/Howen/stream?deviceID=${deviceID}&chs=${chs}&stream=${stream}&wnum=${wnum}&panel=${panel}`, { responseType: 'text',  headers: httpHeaders })
	}




}
